if(typeof require !== 'undefined')
  Factory = require('../../../app/js/lib/Factory.js');

class MailtoFactory extends Factory{

  constructor(options){
    super(options);
  }

  buildMailto(){
    return `${this._buildTo()}?subject=${this._buildSubject()}&body=${this._buildBody()}`;
  }

  lookup(prop, args){
    return this.dictionary[prop](this.home, args);
  }

  _buildTo(){
    return this._to();
  }

  _buildSubject(){
    return encodeURI(this._subject());
  }

  _buildBody(){
    let body = this._body();
    body = body.replace(/&/g, 'and');
    return encodeURI(body);
  }

}


if(typeof module !== 'undefined' && module.exports)
  module.exports = MailtoFactory;
else if(typeof window !== 'undefined')
  window.MailtoFactory = MailtoFactory;
